import { createCustomAction } from 'typesafe-actions';
import { ACTIONBUTTON_EXPRESSIONS_GENERATED } from './constants';
import { ActionButtonExps } from './reducer';

export const actionButtonExpressionsGenerated = createCustomAction(ACTIONBUTTON_EXPRESSIONS_GENERATED, type => {
    return (payload: ActionButtonExps) => ({ type, payload });
});
